import request from '@/utils/request'

// 系统配置
export function getSystemSettings() {
  return request({
    url: '/api/app/system-settings',
    method: 'get'
  })
}

export function updateSystemSettings(data) {
  return request({
    url: '/api/app/system-settings',
    method: 'put',
    data
  })
}

// 自定义配置
export function getCustomerSettings() {
  return request({
    url: '/api/services/app/CustomerSettings/Get',
    method: 'get'
  })
}

export function updateCustomerSettings(data) {
  return request({
    url: '/api/services/app/CustomerSettings/Update',
    method: 'put',
    data
  })
}

// 自定义存储相关接口
/**
 * 创建或更新自定义存储数据
 * @param {Object} data - 包含key和value的对象
 */
export function setCustomStorage(data) {
  return request({
    url: '/api/app/custom-storage/set',
    method: 'post',
    data
  })
}

/**
 * 获取自定义存储数据
 * @param {Object} params - 查询参数
 */
export function getCustomStorage(params) {
  return request({
    url: '/api/app/custom-storage',
    method: 'get',
    params
  })
}

/**
 * 删除自定义存储数据
 * @param {Object} params - 包含key的查询参数
 */
export function deleteCustomStorage(params) {
  return request({
    url: '/api/app/custom-storage',
    method: 'delete',
    params
  })
}

/**
 * 检查自定义存储中是否存在指定key
 * @param {Object} data - 包含key的对象
 */
export function checkCustomStorageExists(data) {
  return request({
    url: '/api/app/custom-storage/exists?key=' + data.key,
    method: 'post'
  })
}